// @flow
import { createSelector } from 'reselect';

export const eventSelector = createSelector(
  state => state.event,
  (event: $ElementType<ReduxState, 'event'>): $ElementType<ReduxState, 'event'> => event
);

export const eventsSelector = createSelector(
  state => state.events,
  (events: $ElementType<ReduxState, 'events'>): $ElementType<ReduxState, 'events'> => events
);
